// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#inner[data-v-1d3355f0]{max-width:960px;margin:0 auto;padding:0 1em}", ""]);
// Exports
module.exports = exports;
